export const fontSizes = [
  '0.75rem', // xxs
  '0.813rem', // xs
  '0.875rem', // sm
  '1rem', // md
  '1.25rem', // lg
  '1.375rem', // xl
  '1.5rem', // xxl
]

fontSizes.xxs = fontSizes[0]
fontSizes.xs = fontSizes[1]
fontSizes.sm = fontSizes[2]
fontSizes.md = fontSizes[3]
fontSizes.lg = fontSizes[4]
fontSizes.xl = fontSizes[5]
fontSizes.xxl = fontSizes[6]

export const fontWeights = [200, 300, 400, 500, 600, 700]

fontWeights.light = fontWeights[0]
fontWeights.normal = fontWeights[1]
fontWeights.medium = fontWeights[2]
fontWeights.semiBold = fontWeights[3]
fontWeights.bold = fontWeights[4]

export const lineHeights = ['1rem', '1.25rem', '1.5rem', '1.75rem']

lineHeights.sm = lineHeights[0]
lineHeights.md = lineHeights[1]
lineHeights.lg = lineHeights[2]
lineHeights.xl = lineHeights[3]
